export default __webpack_public_path__ + "static/media/wag-text-only-logo.5f4f8afa.svg";